import dayjs from 'dayjs';
import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        ownerGroups: null,
    },

    getters: {
        getField,
    },

    actions: {
        getOwnerGroups({ commit }) {
            return axios.get('/api/contacts/owner-groups')
            .then((response) => {
                commit('setOwnerGroups', response.data.data);
            })
            .catch((error) => {
                commit('setOwnerGroups', []);
            });
        },
    },

    mutations: {
        updateField,
        setOwnerGroups(state, ownerGroups) {
            state.ownerGroups = ownerGroups;
        },
    },
};
